/**
 * The sidebar's Home item stays highlighted on the onboarding checklist, which
 * stands in for Home while it is active (86bc2cgxd).
 */
export function isHomeNavActive(routeName) {
    return routeName === 'agent.dashboard' || routeName === 'onboarding.show'
}
